var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.624 3.5h10.5",
    stroke: "#353844",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54 3.5V2.333a1.167 1.167 0 011.167-1.167h2.334a1.167 1.167 0 011.166 1.167V3.5m1.75 0v8.166a1.167 1.167 0 01-1.167 1.167H4.957a1.167 1.167 0 01-1.166-1.167V3.5h8.166zM9.04 6.417v3.5M6.707 6.417v3.5",
    stroke: "#353844",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "media/icons/fi_trash-2a552d83.svg";
export { SvgFiTrash as ReactComponent };